import { render } from "./VariableBody.vue?vue&type=template&id=7440e0d6"
import script from "./VariableBody.vue?vue&type=script&lang=js"
export * from "./VariableBody.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__